var ApplicantAPI = require('../../api').Applicant;
var RepositoryAPI = require("../../api").Repository;
var Promise = require('bluebird');
var ReportAPI = require('../../../common/api').Report;
var FileHandler = require('../../../common/api').FileHandler;

module.exports = function($scope, $window, $document, $timeout, ngDialog) {
  var vm = this;

  vm.invoiceDocumentss = [];
  vm.invoices = [];
  vm.pageNumber = 1;
  vm.numberOfPages = 0;

  vm.init = function(){
    vm.loading = true;
    return ApplicantAPI.GetApplicantDetails().then(function(applicant){
      vm.applicant = applicant;
      var tasks = [
        vm.GetInvoiceDocuments(1),
        vm.GetInvoices(),
        vm.GetInvoiceSummaryReport()
      ]
      return Promise.all(tasks);
    }).finally(function(){
      vm.loading = false;
    })
  }

  vm.GetInvoiceSummaryReport = function(){
    return ReportAPI.GetReportFieldsByName('Applicant Monthly Statement').then(function(result){
      vm.report = result;
    })
  }

  vm.GetInvoices = function(){
    return ApplicantAPI.GetInvoices(vm.applicant.applicantId, "InvoiceListView").then(function(res){
      vm.invoices = [];
      for (var i = 0; i < res.length; i++){
        vm.invoices.push({id: res[i].id, name: res[i].invoiceYear + "-" + getMonthString(res[i].invoiceMonth) + "-Invoice.pdf", invoiceYear: res[i].invoiceYear, invoiceMonth: res[i].invoiceMonth})
      }
    })
  }

  vm.GetInvoiceDocuments = function(page){
    return ApplicantAPI.GetInvoiceDocuments(vm.applicant.applicantId, page).then(function(res){
      vm.invoiceDocuments = res.results;
      vm.numberOfPages = Math.ceil(res.totalResults / 5);
      vm.pageNumber = page;
    })
  }

  vm.pageChange = function(page){
    vm.loading = true;
    vm.GetInvoiceDocuments(page).finally(function(){
      vm.loading = false;
    })
  }

  getMonthString = function(month){
        const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
        ];
        return months[month-1];
    }

  vm.download = function(e, invoice){
    e.target.blur();
    if (invoice.downloading) return;
    invoice.downloading = true;
    RepositoryAPI.GetRepoToken(invoice.blobId).then(function(token) {
      var url = window.conf.doc_repos_url + invoice.datalink + "?t=" + encodeURIComponent(token);
      //download file here (opens in new tab)
      $window.open(url, '_blank');
    }).finally(function(){
      invoice.downloading = false;
    })
  }

  function getExportType(et){
          var exportType = {
            extension: '.pdf',
            mimeType: '',
            type: 0
          };

          switch(et){
            case 1:
              exportType.mimeType = 'application/vnd.ms-excel';
              exportType.extension = '.xls'
              exportType.type = 1;
            break;
            case 2:
              exportType.mimeType = 'application/vnd.msword';
              exportType.extension = '.doc'
              exportType.type = 2;
            break;  
            default:
            break;
          }

          return exportType;
        }

  vm.downloadSummary = function(invoice){
    if (invoice.summaryDownloading) return;
    invoice.summaryDownloading = true;
    var foundInvoice = null;
    for (var i = 0; i < vm.invoices.length; i++) {
      if (vm.invoices[i].name == invoice.fileName){
        foundInvoice = vm.invoices[i]
      }
    }
    if (foundInvoice == null) {
      invoice.summaryDownloading = false;
      return;
    }

    var qry = {
      reportId: vm.report.id,
      reportPath: vm.report.path,
      reportName: vm.report.name,
      reportDescription: vm.report.description,
      type: vm.report.reportType,
      reportParams: { invoiceId: foundInvoice.id },
      exportType: vm.report.exportType
    }

    //defaults to .pdf
    var etValue = 0;
    if(vm.report.exportType){
      etValue = vm.report.exportType;
    }

    var et = getExportType(etValue);

    ReportAPI.GetReport(qry).then(function (data) {
      var filename = qry.reportName + "-" + getMonthString(foundInvoice.invoiceMonth) + "-" + foundInvoice.invoiceYear  + et.extension;
      var streamMime = et.mimeType;

      FileHandler.DownloadFileWithGivenName($document, $timeout, data, filename, streamMime);
        invoice.summaryDownloading = false;
      });
  }

   // Fee report modal and download logic.
  $scope.getSelectedReport = function() {
    // Get report based on given report name.
      ReportAPI.GetReportFieldsByName("ActivityReport").then(function(
      report
    ) {
      // Get report fields based on returned report.
      ReportAPI.GetReportFields(report.id).then(function(reportFields) {
        return (
          ngDialog
            .open({
              template: require("./dialogs/getFeeReport.pug")(),
              controller: require("./dialogs/getFeeReport"),
              plain: true,
              disableAnimation: true,
              resolve: {
                reportFields: function() {
                  return reportFields;
                }
              }
            })
            // Wait for user to click confirm button.
            .closePromise.then(function(obj) {
              if (obj.value.action == "confirm") {
                var qry = {
                  reportId: report.id,
                  reportPath: report.path,
                  reportName: report.name,
                  reportDescription: report.description,
                  type: report.reportType,
                  reportParams: obj.value.value,
                  exportType: report.exportType
                };

                //defaults to .pdf
                var etValue = 0;
                if (report.exportType) {
                  etValue = report.exportType;
                }

                var et = getExportType(etValue);

                ReportAPI.GetReport(qry).then(function(data) {
                  var filename = qry.reportName + et.extension;
                  var streamMime = et.mimeType;

                  FileHandler.DownloadFileWithGivenName(
                    $document,
                    $timeout,
                    data,
                    filename,
                    streamMime
                  );
                  $scope.loading = false;
                });
                if (obj.action == "cancel") {
                }
              }
            })
        );
      });
    });
  };

  vm.init();
};
